import { Button, DatePicker, Input, message, Space, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { serverFetch } from "@server";
import { fmtDate, strDate2Server } from "@extensions/convert";
import Order from "./order";

const STORAGE_KEY_FROM = "orders_dateFrom";
const STORAGE_KEY_TO = "orders_dateTo";

const loadSavedPeriod = () => {
  try {
    const from = localStorage.getItem(STORAGE_KEY_FROM);
    const to = localStorage.getItem(STORAGE_KEY_TO);
    if (from && to) {
      const dFrom = dayjs(from, "YYYY-MM-DD", true);
      const dTo = dayjs(to, "YYYY-MM-DD", true);
      if (dFrom.isValid() && dTo.isValid()) {
        return { dateFrom: dFrom, dateTo: dTo };
      }
    }
  } catch (e) {}
  return {
    dateFrom: dayjs().startOf("month"),
    dateTo: dayjs().endOf("month"),
  };
};

const Orders = () => {
  const { id: idParam } = useParams();
  const navigate = useNavigate();
  const saved = loadSavedPeriod();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(saved.dateFrom);
  const [dateTo, setDateTo] = useState(saved.dateTo);
  const [searchText, setSearchText] = useState("");
  const selectedOrderId = idParam != null ? (parseInt(idParam, 10) || null) : null;

  useEffect(() => {
    if (dateFrom) {
      try {
        localStorage.setItem(STORAGE_KEY_FROM, dateFrom.format("YYYY-MM-DD"));
      } catch (e) {}
    }
    if (dateTo) {
      try {
        localStorage.setItem(STORAGE_KEY_TO, dateTo.format("YYYY-MM-DD"));
      } catch (e) {}
    }
  }, [dateFrom, dateTo]);

  const getData = () => {
    setLoading(true);
    const queryParams = {};
    if (dateFrom) queryParams.dateFrom = strDate2Server(dateFrom);
    if (dateTo) queryParams.dateTo = strDate2Server(dateTo);
    if (searchText.trim()) queryParams.search = searchText.trim();
    serverFetch("Order", { queryParams })
      .then((data) => {
        setItems(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || e.message || "Ошибка загрузки заказов");
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    { dataIndex: "id", title: "#", width: 80 },
    { dataIndex: "docDate", title: "Дата", width: 110, render: fmtDate },
    { dataIndex: "companyName", title: "Компания", width: 200 },
    { dataIndex: "docNum", title: "Номер док.", width: 100 },
    { dataIndex: "depNo", title: "Отдел", width: 80 },
    { dataIndex: "status", title: "Статус", width: 120 },
    { dataIndex: "predName", title: "Клиент", width: 200, ellipsis: true },
    { dataIndex: "address", title: "Адрес", ellipsis: true },
    { dataIndex: "area", title: "Площадь", width: 90, render: (v) => (v != null ? Number(v) : "—") },
    { dataIndex: "syma", title: "Сумма", width: 110, render: (v) => (v != null ? Number(v) : "—") },
    { dataIndex: "debet", title: "Долг", width: 110, render: (v) => (v != null ? Number(v) : "—") },
    { dataIndex: "phone", title: "Телефон", width: 130 },
    { dataIndex: "finDate", title: "Дата гот.", width: 110, render: fmtDate },
    // { dataIndex: "orderGuid", title: "GUID", width: 120, ellipsis: true },
  ];

  return (
    <div className="page">
      <Space style={{ marginBottom: 16 }} wrap>
        <span>Период с</span>
        <DatePicker
          value={dateFrom}
          onChange={setDateFrom}
          format="DD.MM.YYYY"
          allowClear={false}
        />
        <span>по</span>
        <DatePicker
          value={dateTo}
          onChange={setDateTo}
          format="DD.MM.YYYY"
          allowClear={false}
        />
        <Input
          placeholder="Поиск"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && getData()}
          style={{ width: 200 }}
          allowClear
        />
        <Button type="primary" onClick={getData} loading={loading}>
          Обновить
        </Button>
      </Space>
      <Table
        columns={columns}
        dataSource={items}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 50 }}
        scroll={{ x: "max-content" }}
        size="small"
        onRow={(record) => ({ onClick: () => navigate(`/orders/${record.id}`), style: { cursor: "pointer" } })}
      />
      {selectedOrderId != null && (
        <Order orderId={selectedOrderId} onClose={() => navigate("/orders")} />
      )}
    </div>
  );
};

export default Orders;
